import type { SearchClient } from 'algoliasearch/lite'
import { useAlgoliaSearchClient } from '~/composables/algolia/useAlgoliaSearchClient'
import { useSearchEngine } from '~/composables/search/useSearchEngine'
import { useTypesenseHandle } from '~/composables/search/useTypesenseHandle'

export interface TypesenseClientHandle {
  engine: 'typesense'
  host: string
  apiKey: string
}

export type SearchClientHandle =
  | { engine: 'algolia'; client: SearchClient }
  | TypesenseClientHandle

/**
 * Engine-aware replacement for useAlgoliaSearchClient as the transport choke
 * point. Snapshots the engine at call time — call it inside fetch handlers (or
 * rebuild on engine change) so a post-hydration switch is picked up.
 * `clientOnly`: see useSearchEngine — for client-only data only.
 */
export const useSearchClient = ({
  clientOnly = false,
}: { clientOnly?: boolean } = {}): SearchClientHandle => {
  const engine = useSearchEngine({ clientOnly })

  if (engine.value === 'algolia') {
    return { engine: 'algolia', client: useAlgoliaSearchClient() }
  }

  return useTypesenseHandle()
}
